/* Kahwa - WCAG 2.2 AA remediation behaviours (V1.8, 2026-09-09).
   Additive only: no theme handler is replaced or unbound. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1.3.1 - cart drawer emitted h3 "Cart" then h5 error heading on every page,
     producing a 3 -> 5 level skip site-wide and placing a level-3 heading
     ahead of each page's h1. aria-level is authoritative for AT. */
  function fixDrawerHeadings() {
    document.querySelectorAll('.drawer__heading').forEach(function (el) {
      el.setAttribute('role', 'heading');
      el.setAttribute('aria-level', '2');
    });
    document.querySelectorAll('.cart__errors__heading').forEach(function (el) {
      el.setAttribute('role', 'heading');
      el.setAttribute('aria-level', '3');
    });
    document.querySelectorAll('.cart__errors').forEach(function (el) {
      if (!el.hasAttribute('role')) el.setAttribute('role', 'alert');
    });
  }

  /* 4.1.2 / 2.1.2 - the cart drawer had no dialog semantics and did not close
     on Escape. Semantics are applied only while it is open, keyed on the
     theme's own is-open class, so page content is not hidden from AT when
     the drawer is shut. */
  function wireCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var opener = null;

    function isOpen() { return drawer.classList.contains('is-open'); }

    function sync() {
      if (isOpen()) {
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        if (!drawer.getAttribute('aria-label')) drawer.setAttribute('aria-label', 'Shopping cart');
      } else {
        drawer.removeAttribute('role');
        drawer.removeAttribute('aria-modal');
      }
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-drawer-toggle="cart"], a[href$="/cart"], [data-cart-drawer-open], button[name="add"]');
      if (t) opener = t;
    }, true);

    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (!isOpen()) return;
      var closer = drawer.querySelector('[data-cart-drawer-close]');
      if (!closer) return;
      closer.click();
      sync();
      if (opener && document.contains(opener)) opener.focus();
    });
  }

  /* 4.1.2 - hamburger pointed aria-controls at "header-menu", an id that does
     not exist in this theme. Repoint it at the real mobile menu, or drop it. */
  function fixAriaControls() {
    document.querySelectorAll('[aria-controls]').forEach(function (el) {
      var id = el.getAttribute('aria-controls');
      if (!id || document.getElementById(id)) return;
      var target = null;
      if (el.classList.contains('header__mobile__hamburger') || el.hasAttribute('data-drawer-toggle')) {
        target = document.querySelector('[id^="mobile-menu-"]');
      }
      if (target && target.id) { el.setAttribute('aria-controls', target.id); }
      else { el.removeAttribute('aria-controls'); }
    });
  }

  /* 4.1.2 - carousels (Flickity on the wholesale logo slider, and the theme's
     own sliders) mark off-screen slides aria-hidden="true" but leave the
     buttons and links inside them in the tab order, so keyboard users land on
     content screen readers are told does not exist. Elements are untabbed here
     and restored when their slide becomes visible again. Restoring removes the
     attribute rather than replaying an earlier tabindex value, which is
     equivalent for the links and buttons this applies to. */
  function fixAriaHiddenFocus() {
    document.querySelectorAll('[aria-hidden="true"]').forEach(function (host) {
      host.querySelectorAll('a[href], button, input, select, textarea, iframe, [tabindex]').forEach(function (f) {
        if (f.tabIndex >= 0) {
          f.setAttribute('tabindex', '-1');
          f.setAttribute('data-kahwa-untabbed', '');
        }
      });
    });
    document.querySelectorAll('[data-kahwa-untabbed]').forEach(function (f) {
      if (!f.closest('[aria-hidden="true"]')) {
        f.removeAttribute('tabindex');
        f.removeAttribute('data-kahwa-untabbed');
      }
    });
  }

  /* 1.3.1 - navigation landmarks shipped unlabelled. Every name assigned here
     must be unique within a page: an earlier revision of the fallback below
     gave the first still-unlabelled nav the name "Main", and on the search and
     collection templates that was the pagination nav, producing two navigation
     landmarks both announced as "Main". */
  function labelLandmarks() {
    document.querySelectorAll('nav.header__menu').forEach(function (n) { if (!n.getAttribute('aria-label')) n.setAttribute('aria-label', 'Main'); });
    document.querySelectorAll('nav.drawer__menu').forEach(function (n) { if (!n.getAttribute('aria-label')) n.setAttribute('aria-label', 'Mobile'); });
    document.querySelectorAll('nav.collection__nav').forEach(function (n) { if (!n.getAttribute('aria-label')) n.setAttribute('aria-label', 'Filter and sort'); });
    document.querySelectorAll('nav.pagination-custom, nav.pagination').forEach(function (n) { if (!n.getAttribute('aria-label')) n.setAttribute('aria-label', 'Pagination'); });
    var extra = 0;
    document.querySelectorAll('nav:not([aria-label]):not([aria-labelledby])').forEach(function (n) {
      extra += 1;
      n.setAttribute('aria-label', extra === 1 ? 'Secondary' : 'Secondary ' + extra);
    });
  }

  /* 1.3.1 - on the search template the only headings are the filter and sort
     controls. The results summary ("53 results found for ...") renders as a
     paragraph, so no heading identifies the results themselves. Heading
     semantics are applied to the existing element rather than changing its
     tag, which leaves the visual presentation untouched. */
  function fixSearchHeading() {
    document.querySelectorAll('.search__caption').forEach(function (el) {
      if (el.getAttribute('role') === 'heading') return;
      el.setAttribute('role', 'heading');
      el.setAttribute('aria-level', '1');
    });
  }

  /* 4.1.2 / 2.4.1 - embedded players shipped with no title, so they are
     announced only as "frame". Source is fixed on the About page and the three
     articles that carry embeds; this covers app-injected frames. */
  function titleFrames() {
    document.querySelectorAll('iframe:not([title])').forEach(function (f) {
      var src = f.getAttribute('src') || '';
      if (src.indexOf('vimeo') > -1 || src.indexOf('youtube') > -1) { f.setAttribute('title', 'Video player'); return; }
      if (src.indexOf('google.com/maps') > -1) { f.setAttribute('title', 'Map'); return; }
      if (src.indexOf('web-pixels') > -1) { f.setAttribute('title', 'Analytics'); f.setAttribute('aria-hidden', 'true'); return; }
      f.setAttribute('title', 'Embedded content');
    });
  }

  /* 4.1.2 - search result tiles carried role="option" with no listbox parent on
     the search page, and wrapped an <a>, which is nested-interactive. Source is
     fixed in snippets/search-results-item.liquid; this catches app-injected
     and cached markup. */
  function fixSearchRoles() {
    document.querySelectorAll('[role="option"]').forEach(function (el) {
      var lb = el.closest('[role="listbox"]');
      if (!lb || el.querySelector('a, button')) {
        el.removeAttribute('role');
        el.removeAttribute('aria-selected');
      }
    });
  }

  /* 1.1.1 - Stamped injects customer photo tiles that carry aria-label but no
     alt attribute. aria-label satisfies the accessible name, but mirroring it
     into alt keeps the markup valid for tools that check the attribute. */
  function mirrorImageLabels() {
    document.querySelectorAll('img[aria-label]:not([alt])').forEach(function (img) {
      img.setAttribute('alt', img.getAttribute('aria-label'));
    });
  }

  /* 4.1.2 - aria-label on a plain div is a prohibited attribute. */
  function fixMarqueeSemantics() {
    document.querySelectorAll('.logo-marquee__viewport[aria-label]').forEach(function (el) {
      if (!el.getAttribute('role')) el.setAttribute('role', 'group');
    });
  }

  function makeToggle(label, extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kahwa-motion-toggle' + (extraClass ? ' ' + extraClass : '');
    b.setAttribute('aria-pressed', 'false');
    b.textContent = label;
    return b;
  }

  /* 2.2.2 - the wholesale logo marquee auto-scrolls indefinitely with no stop
     control. It already honours prefers-reduced-motion; this adds the explicit
     mechanism the success criterion requires. */
  function addMarqueeControl() {
    if (reduceMotion) return;
    document.querySelectorAll('.logo-marquee').forEach(function (section) {
      var track = section.querySelector('.logo-marquee__track');
      var wrap = section.querySelector('.logo-marquee__wrapper');
      if (!track || !wrap || section.querySelector('.kahwa-motion-toggle')) return;
      var btn = makeToggle('Pause');
      btn.addEventListener('click', function () {
        var paused = track.style.animationPlayState === 'paused';
        track.style.animationPlayState = paused ? 'running' : 'paused';
        btn.setAttribute('aria-pressed', paused ? 'false' : 'true');
        btn.textContent = paused ? 'Pause' : 'Play';
      });
      var holder = document.createElement('div');
      holder.style.textAlign = 'center';
      holder.appendChild(btn);
      wrap.appendChild(holder);
    });
  }

  /* 2.2.2 - the hero video plays, loops and exposes no controls. The
     element is inserted by video-background.js after DOMContentLoaded, so this
     also runs from the deferred observer.
     10/8: the video no longer carries the autoplay attribute (video-background.js
     starts it with play()), so it is matched by its player as well. The theme
     also calls play() each time the video scrolls back into view, which used to
     undo a visitor's pause; a pause now holds until the visitor presses Play. */
  function addVideoControl() {
    document.querySelectorAll('video[autoplay]:not([controls]), .video__player video:not([controls])').forEach(function (v) {
      var host = v.closest('.video__player') || v.parentElement;
      if (!host || host.querySelector('.kahwa-motion-toggle--video')) return;
      host.classList.add('kahwa-motion-toggle-host');
      var btn = makeToggle('Pause video', 'kahwa-motion-toggle--video');
      function hold() { v.dataset.kahwaPaused = '1'; v.pause(); btn.textContent = 'Play video'; btn.setAttribute('aria-pressed', 'true'); }
      v.addEventListener('play', function () { if (v.dataset.kahwaPaused === '1') v.pause(); });
      btn.addEventListener('click', function () {
        if (v.dataset.kahwaPaused === '1' || v.paused) { v.dataset.kahwaPaused = '0'; v.play(); btn.textContent = 'Pause video'; btn.setAttribute('aria-pressed', 'false'); }
        else { hold(); }
      });
      host.appendChild(btn);
      if (reduceMotion) { hold(); }
    });
  }

  /* 2.1.1 - scrollable regions must be reachable by keyboard. */
  function focusScrollables() {
    document.querySelectorAll('[data-scroll-lock-scrollable], .drawer__body, .drawer__items').forEach(function (el) {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    });
  }

  function run() {
    fixDrawerHeadings();
    fixAriaControls();
    labelLandmarks();
    fixSearchHeading();
    titleFrames();
    fixSearchRoles();
    mirrorImageLabels();
    fixMarqueeSemantics();
    addMarqueeControl();
    addVideoControl();
    focusScrollables();
    fixAriaHiddenFocus();
  }

  function init() {
    run();
    wireCartDrawer();
    var pending = false;
    var deferred = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        titleFrames();
        fixSearchRoles();
        fixDrawerHeadings();
        fixMarqueeSemantics();
        mirrorImageLabels();
        addMarqueeControl();
        addVideoControl();
        fixAriaHiddenFocus();
      });
    });
    deferred.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    window.addEventListener('load', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
